export function makeDivs(count, className) {
  return Array.from({ length: count }, () => `<div class="${className}"></div>`).join('\n');
}

export function makePolaroids(count, checkbox = true) {
  return Array.from(
    { length: count },
    () => `<div class="polaroid">\n  <div class="img"></div>\n  ${checkbox ? '<input type="checkbox" />' : ''}\n</div>`
  ).join('\n');
}

export function makePoemWords(words) {
  return words.map((word) => `<span>${word}</span>`).join(' ');
}
